import { FC } from "react";

import { MazakaSelect } from "apps/Common/MazakaSelect";
import { GeneralSelectInputs } from "models/Client/GeneralSelectInputs";
import useCapitalize from "../Adress/helpers/useCapitalize";
import { useGetCompanies } from "./ServerSideStates";




const GeneralCompnyTypes: FC<GeneralSelectInputs> = (props) => {
  const companies =useGetCompanies()
  let { capitalize } = useCapitalize();

  return (
    <>
      <MazakaSelect
        name={props.name}
        xs={props.xs}
        sm={props.sm}
        md={props.md}
        lg={props.lg}
        xl={props.xl}
        loading={companies.isLoading || companies.isFetching}
        disabled={companies.isLoading || companies.isFetching || props.disabled}
        className={props.className}
        showSearch={true}
        allowClear={props.allowClear || false}
        filterOption={(input, option: any) =>
          (option.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        label={props.label}
        options={
          companies?.data?.data
            ? companies.data.data?.map((item: any) => {
                return {
                  key: item.id,
                  value: item.id,
                  label: capitalize(item.value|| " "),
                  optionId: item.optionId
                };
              })
            : []
        }
        placeholder={props.placeholder}
        mode={props.mode}
        onChange={props.onChange}
        value={props.value}
        rules={props.rules}
      />
     
    </>
  );
};

export default GeneralCompnyTypes;
